<script>
  import { Icon, CheckCircle, XCircle, XMark, Megaphone } from "svelte-hero-icons";
  import { toRelativeTime } from "$lib/utils/time.js";
  import { createEventDispatcher } from "svelte";
  import { tooltip } from "$lib/utils/tooltip.js";

  const dispatch = createEventDispatcher();

  export let item;
</script>

<div
  class="group relative flex flex-col p-4 text-sm hover:bg-blue-50 dark:hover:bg-white/5 cursor-default"
  on:click={() => dispatch("read", item)}
  on:keydown={(e) => {
    if (e.key === "Enter" || e.key === "Space") {
      e.preventDefault();
      dispatch("read", item);
    }
  }}
  tabindex="0"
  role="button"
  aria-label="Mark notification seen"
>
  <div
    class:hidden={item.read_at}
    class="absolute top-2 left-2 rounded-full w-[6px] h-[6px] bg-blue-200 border border-blue-600"
  ></div>
  <button
    class="invisible group-hover:visible absolute top-4 right-4 text-white hover:bg-slate-600 bg-slate-400 rounded-full w-3 h-3 inline-flex justify-center items-center"
    on:click|stopPropagation={() => dispatch("archive", item)}
    use:tooltip
    aria-label="Archive this notification"
  >
    <Icon src={XMark} mini class="w-3 h-3" />
  </button>
  {#if item.source.key === "automation-success"}
    <div class="flex items-start">
      <Icon src={CheckCircle} class="shrink-0 inline-block h-6 w-6 text-green-400 mr-2" />
      <a class="cursor-pointer grow flex flex-col" href={item.data.action_url}>
        Automation succeeded!
        <span class="font-bold text-xs">{item.data.device_name}</span>
        <div class="text-slate-400 text-xs mt-2">
          {toRelativeTime(item.inserted_at)}
        </div>
      </a>
    </div>
  {:else if item.source.key === "automation-failed"}
    <div class="flex items-start">
      <Icon src={XCircle} class="shrink-0 inline-block h-6 w-6 text-red-400 mr-2" />
      <a class="cursor-pointer grow flex flex-col" href={item.data.action_url}>
        <span>Automation Failed!</span>
        <span class="font-bold text-xs">{item.data.device_name}</span>
        <div class="text-slate-400 text-xs mt-2">
          {toRelativeTime(item.inserted_at)}
        </div>
      </a>
    </div>
  {:else if item.source.key === "blog-published"}
    <div class="flex items-start">
      <Icon src={Megaphone} class="shrink-0 inline-block h-6 w-6 text-indigo-400 mr-2" />
      <a class="cursor-pointer grow flex flex-col" href={item.data.blog_url}>
        <span>New from TV Labs</span>
        <span class="font-bold text-xs">{item.data.blog_title}</span>
        <div class="text-slate-400 text-xs mt-2">
          {toRelativeTime(item.inserted_at)}
        </div>
      </a>
    </div>
  {:else}
    {#each item.blocks as block}
      <!-- eslint-disable-next-line -->
      <div>{@html block.rendered}</div>
    {/each}
  {/if}
</div>
